import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=12eb68e9&"
import script from "./AppProfile.vue?vue&type=script&lang=js&"
export * from "./AppProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12eb68e9')) {
      api.createRecord('12eb68e9', component.options)
    } else {
      api.reload('12eb68e9', component.options)
    }
    module.hot.accept("./AppProfile.vue?vue&type=template&id=12eb68e9&", function () {
      api.rerender('12eb68e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widget/AppProfile.vue"
export default component.exports